import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../../auth/auth.service';
import {Market} from '../../../models/dealers/market.enum';

@Component({
  selector: 'app-admin-menu',
  templateUrl: './admin-menu.component.html',
  styleUrls: ['./admin-menu.component.scss']
})
export class AdminMenuComponent implements OnInit {

  showPromotions = false;
  showActionPeriods = false;
  showE4n = false;

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    this.showPromotions = this.authService.market() === Market.BE;
    this.showActionPeriods = this.authService.market() === Market.BE;
    this.showE4n = this.authService.market() === Market.BE;
  }

}
